// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sep {
  font-family: 'Material Symbols Outlined';
  font-size: 0.8em;
  opacity: 0.6;
  content: "arrow_forward_ios";
}
.gBCUM1mxIaQRmJMmNsAg {
  user-select: none;
  display: flex;
  align-items: center;
  background-color: var(--background);
  color: var(--color);
  font-size: 1.1em;
  margin: 0.4em;
  padding: 0.2em 0.4em;
  border: 1px solid transparent;
  transition: border 0.6s;
  border-radius: 6px;
}
.gBCUM1mxIaQRmJMmNsAg em {
  background-color: var(--selected-background);
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 0.3em;
  padding: 0 0.4em;
  cursor: pointer;
}
.gBCUM1mxIaQRmJMmNsAg em > span {
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.gBCUM1mxIaQRmJMmNsAg .connection.icon {
  font-size: 1.1em;
  padding-right: 0.2em;
  cursor: pointer;
}
.gBCUM1mxIaQRmJMmNsAg > span {
  flex: auto 0 1;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 0.2em;
  border-radius: 6px;
}
.gBCUM1mxIaQRmJMmNsAg > span:hover {
  background-color: var(--selected-background);
}
.gBCUM1mxIaQRmJMmNsAg > i {
  flex: auto 0 0;
  font-size: 0.7em;
  opacity: 0.6;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sep": `sep`,
	"root": `gBCUM1mxIaQRmJMmNsAg`,
	"connection": `connection`,
	"icon": `icon`
};
export default ___CSS_LOADER_EXPORT___;
